export default "__VITE_ASSET__7b4feaf9__"